import axios from "axios";
import React, { useContext, useCallback } from "react";
// import { BASE_URL } from "../constants/api_urls";
import { AppStateContext } from "../context/AppContext";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";
import apiClient from "../helper/apiClient";

const useRequest = () => {
  const { setLoading } = useContext(AppStateContext);

  const request = useCallback(
    async ({
      url,
      method: tmethod,
      data,
      onSuccess,
      onError,
      header,
      onErrorSubmit,
    }) => {
      const method = tmethod.trim().toUpperCase();

      const headers = {
        ...header,
      };

      setLoading(true);
      try {
        const response = await apiClient({
          url,
          method,
          data,
          headers: { ...headers },
        });

        if (onSuccess) {
          setLoading(false);
          onSuccess(response.data);
        }
        if (onError) {
          setLoading(false);
          console.log(onError, "onError Jay");
        } else if (onErrorSubmit) {
          onErrorSubmit(response.data);
        }
        setLoading(false);
        return response.data;
      } catch (err) {
        console.log(err);
        if (err?.response?.data?.message === "jwt expired") {
          setLoading(false);
          localStorage.removeItem("token");
          localStorage.removeItem("access_token");
          localStorage.removeItem("user");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("session_id");
          ShowToast("Session expired. Please login again.", Severty.ERROR);
          window.location.assign("/login");
        }
        if (onError) {
          onError(err);
        }
        setLoading(false);
        // throw err;
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  return { request };
};

export default useRequest;
